import Menu from "../components/Menu";

export default function Home() {
    return (
        <div>
            <Menu />
        </div>
    )
}